import { createSvgIcon } from "@mui/material";

export const RevenueIcon = createSvgIcon(
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M25.7775 5.9326L20.0662 0.221297C19.7823 -0.0737655 19.2724 -0.0737655 18.9891 0.221297L13.2777 5.93311C13.0599 6.15098 12.9949 6.47854 13.1127 6.76345C13.2305 7.04784 13.5083 7.23372 13.8165 7.23372H16.3185V25.2381C16.3185 25.6586 16.6597 25.9999 17.0802 25.9999H21.9755C22.396 25.9999 22.7372 25.6586 22.7372 25.2381V7.23321H25.2392C25.5475 7.23321 25.8253 7.04785 25.9431 6.76294C26.0609 6.47803 25.9959 6.15047 25.778 5.9326H25.7775Z"
        fill="#2962FF"
      />
      <path
        d="M13.8152 10.6055H8.91992C8.49945 10.6055 8.1582 10.9467 8.1582 11.3672V25.2382C8.1582 25.6587 8.49945 26 8.91992 26H13.8152C14.2357 26 14.577 25.6587 14.577 25.2382V11.3672C14.577 10.9467 14.2357 10.6055 13.8152 10.6055Z"
        fill="#2962FF"
      />
      <path
        d="M5.65703 17.1328H0.761719C0.34125 17.1328 0 17.4741 0 17.8946V25.2381C0 25.6586 0.34125 25.9999 0.761719 25.9999H5.65703C6.0775 25.9999 6.41875 25.6586 6.41875 25.2381V17.8946C6.41875 17.4741 6.0775 17.1328 5.65703 17.1328Z"
        fill="#2962FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_8460_47732">
        <rect width="26" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "Revenue Icon"
);
